<template>
  <div id="wechat">
    <div class="content loading" v-if="$route.query.wxLogin">
      <p>正在登录 AnyTeach 约课平台...</p>
    </div>
    <div class="content loading" v-if="$route.query.jwt">
      <p>
        正在跳转...
        <br />
        <span class="small">{{ version }}</span>
      </p>
    </div>
  </div>
</template>
<script>
import { version } from "../../../package.json"
export default {
  name: "Login",
  data() {
    return {
      path: this.$route.query.path || "/",
      env: process.env.VUE_APP_ENV,
      version,
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.login
    },
    fullPath() {
      return this.$store.state.fullPath
    },
  },
  methods: {
    isWechat() {
      return (
        window.navigator.userAgent.toLowerCase().includes("micromessenger") ||
        this.env === "development"
      )
    },
    wxLogin() {
      const redirectUrl = encodeURIComponent(`${location.origin}${this.fullPath}`)
      const url = `${window.PHP_ROOT}/index/auth/wxLogin?env=${this.env}&redirectUrl=${redirectUrl}`
      alert(url)
      return location.replace(url)

      // let redirectUrl = encodeURIComponent(`${window.homePageUrl}/login`)
      // const fullPath = encodeURIComponent(this.fullPath)

      // if (
      //   window.navigator.userAgent.includes("Android") &&
      //   window.navigator.userAgent.includes("MicroMessenger/7.0.9")
      // ) {
      //   redirectUrl = encodeURIComponent(`${window.homePageUrl}${this.fullPath}`)
      //   let url = `${window.PHP_ROOT}/index/auth/wxLogin?env=${this.env}&redirectUrl=${redirectUrl}`
      //   return window.location.replace(url)
      // }
      // let url = `${window.PHP_ROOT}/index/auth/wxLogin?env=${this.env}&redirectUrl=${redirectUrl}&path=${fullPath}`
      // window.location.replace(url)
    },
  },
  mounted() {
    if (this.$route.query.wxLogin && this.isWechat()) {
      this.wxLogin()
    }
    if (this.$route.query.jwt) {
      this.$store.commit("jwt", this.$route.query.jwt)
      return this.$router.push(this.$route.query.path || "/")
    }
  },
}
</script>
<style scoped lang="scss">
// @import "../../../static/css/public.scss";

#wechat {
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      font-size: 1rem;
      color: $black;
      opacity: 0.7;
      @include avenir();
      font-weight: 400;
    }
  }
  .content {
    position: relative;
    height: 100vh;
    text-align: center;
    .title {
      @include avenir-demi();
      font-size: 25px;
      text-align: center;
      font-weight: bold;
      padding: 10vh 0 10px 0;
    }
    p {
      word-break: break-all;
      padding: 0 5%;
      .small {
        padding: 15px 0 0 0;
        font-size: 0.875rem;
        opacity: 0.5;
      }
    }
    .button {
      position: absolute;
      bottom: 30px;
      padding: 15px;
      border-radius: 5px;
      text-align: center;
      width: 90%;
      left: 5%;
      font-size: 15px;
      transition: 0.1s;
      &:active {
        opacity: 0.7;
      }
      span {
        font-weight: 500;
      }
    }
    .blue-button {
      background: $blue;
      color: white;
    }
    .black-button {
      color: white;
      background: $black;
    }
  }
}
</style>
